import React, {useState, useEffect} from 'react';
import Loader from "react-loader-spinner";
import { useDispatch } from 'react-redux';
import { FiDownload } from 'react-icons/fi';
import { AiFillFolder } from "react-icons/ai";
import * as formActions from '../../Redux/Actions/form';
import { toastMessage } from '../utils/toast';
import PreviewImgModal from './previewImg';
import { ContainerDiv, ContainerOuter, LoaderContainer } from '../Mapping/styles';
import { getParams} from '../utils';
import Warning from '../Ui/400';
import { clearSession } from '../utils/initiate';
import DocumentDeleteModal from './deleteDocument';
import AamerLoader from '../Ui/Loader';

const UserDocuments = ({ history, match }) => {

    const [lang, setLang] = useState('en');
    const [loading, setLoading] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [data, setData] = useState([]);
    const [tag, setTag] = useState([]);
    const [selectedTag, setSelectedTag] = useState('');
    const [imgSrcModal, setImgSrcModal] = useState(false);
    const [imgSrcModalLoading, setImgSrcModalLoading] = useState(false);
    const [imgSrc, setImgSrc] = useState('');
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteDocumentID, setDeleteDocumentID] = useState('');
    const [deleteDocumentLoading, setDeleteDocumentLoading] = useState(false);
    const [errStatus, setErrStatus] = useState(200);
    const dispatch = useDispatch();
    const {userID} = match.params;

    useEffect(() => {
        handleLoadDocuments();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleLoadDocuments = () => {
        setLoading(true);
        formActions.listUserDocuments(userID).then(res => {
            if(res && res.data){
                setData(res.data);
                setTag(Object.keys(res.data));
            }else{
                toastMessage('error', (res && res.message) || `Unable to load the documents`);
            }
            setLoading(false);
        }).catch(err => {
            setErrStatus(err.response.status);
            (err.response.status === 401) && clearSession(dispatch, history);
        });

        let params = getParams(window.location.search);
        setLang(params.lang);
    };

    const handlePreviewDocument = (documentID) => {
        setImgSrcModal(true);
        setImgSrcModalLoading(true);
        formActions.previewDocument(userID, documentID).then(res => {
            setImgSrc(res.data);
            setImgSrcModalLoading(false);
        })
        .catch(err => {
            setErrStatus(err.response.status);
            (err.response.status === 401) && clearSession(dispatch, history);
        });
    };

    const handleRemoveDocument = (documentID) => {
        setDeleteDocumentLoading(true);
        formActions.removeDocument(userID, documentID).then(res => {
            setDeleteModal(false);
            setDeleteDocumentLoading(false);
            handleLoadDocuments();
            toastMessage('success', `Successfully deleted the document`);
        }).catch(err => {
            console.log('Something Went Wrong', err);
        });
    };

    const handleDownloadDocument = (documentID) => {
        setDownloading(true);
        formActions.previewDocument(userID, documentID).then(res => {
            var binary_string = window.atob(res.data.content);
            var len = binary_string.length;
            var bytes = new Uint8Array(len);
            for (var i = 0; i < len; i++) {
                bytes[i] = binary_string.charCodeAt(i);
            }
            var blob = new Blob([bytes], { type: "text/plain" });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = res.data.fileName;
            link.click();
            setDownloading(false);
        })
        .catch(err => {
            setErrStatus(err.response.status);
            (err.response.status === 401) && clearSession(dispatch, history);
        });
    };

    let isArabic = (lang === 'ar');

    if(errStatus === 400){
        return <Warning history={history} />;
    }

    return(
        <>
            {loading ? <LoaderContainer><AamerLoader /></LoaderContainer>
            : <ContainerOuter className="p-10"><ContainerDiv>
                {/* <div className="mb-4">
                    <span className="card-label font-weight-bolder">Document Vault</span>
                    <span className="card-label font-weight-bolder mr-2 ml-2">/</span>
                    <span className="card-label font-weight-bolder text-dark cursor-pointer" onClick={() => setSelectedTag('')}>{userID}</span>
                    {(selectedTag !== '') && <><span className="card-label font-weight-bolder mr-2 ml-2">/</span>
                    <span className="card-label font-weight-bolder text-dark">{selectedTag}</span></>}
                </div> */}
                {((Object.keys(data).length === 0) || (tag.length === 0)) && <h5 className="text-center title">{isArabic ? 'لاتوجد بيانات' : 'No data found'}</h5>}
                <div className="d-flex align-items-center flex-wrap ml-9">
                    {(selectedTag === '') ? (tag.map(tag => ((tag !== 'undefined') && (tag !== '_')) ? <div key={tag} onClick={() => setSelectedTag(tag)} className="document d-flex justify-content-start font-weight-bold my-2 mr-4" style={{width: '130px', borderRadius: '7px', flexDirection: 'column', alignItems: 'center'}}><AiFillFolder size={140} /> <p>{tag}</p></div> 
                            : <>{data.undefined && data.undefined.map(({thumbnailUrl, contentType, documentId, fileName}, index) => 
                                <DisplayDocument index={index} thumbnailUrl={thumbnailUrl} contentType={contentType} documentId={documentId} fileName={fileName} setDeleteModal={setDeleteModal} setDeleteDocumentID={setDeleteDocumentID} handlePreviewDocument={handlePreviewDocument} handleDownloadDocument={handleDownloadDocument} />)}
                                {data._ && data._.map(({thumbnailUrl, contentType, documentId, fileName}, index) => 
                                <DisplayDocument index={index} thumbnailUrl={thumbnailUrl} contentType={contentType} documentId={documentId} fileName={fileName} setDeleteModal={setDeleteModal} setDeleteDocumentID={setDeleteDocumentID} handlePreviewDocument={handlePreviewDocument} handleDownloadDocument={handleDownloadDocument} />)}
                            </>
                        )) : data[selectedTag].map(({thumbnailUrl, contentType, documentId, fileName}, index) => 
                        <DisplayDocument index={index} thumbnailUrl={thumbnailUrl} contentType={contentType} documentId={documentId} fileName={fileName} setDeleteModal={setDeleteModal} setDeleteDocumentID={setDeleteDocumentID} handlePreviewDocument={handlePreviewDocument} handleDownloadDocument={handleDownloadDocument} />
                    )}
                </div>
                {imgSrcModal && <PreviewImgModal loading={imgSrcModalLoading} data={imgSrc} showModal={imgSrcModal} handleCancel={() => setImgSrcModal(false)} />}
                {downloading && <div>
                    <div className="modal" style={{display: 'block'}}>
                        <div className="modal-body d-flex justify-content-center">
                            <LoaderContainer><Loader type="ThreeDots" color="#fff" height={40} width={40} /></LoaderContainer>
                        </div>
                    </div>
                    <div className="modal-backdrop show" style={{opacity: 0.6}}></div>
                </div>}
                {deleteModal && <DocumentDeleteModal showModal={deleteModal} loading={deleteDocumentLoading} handleOk={() => handleRemoveDocument(deleteDocumentID)} handleModalClose={() => setDeleteModal(false)} />}
            </ContainerDiv></ContainerOuter>}
        </>
    );
};

const DisplayDocument = ({index, thumbnailUrl, contentType, documentId, fileName, handlePreviewDocument, handleDownloadDocument, setDeleteModal, setDeleteDocumentID}) => {
    fileName = (fileName && fileName.length > 10) ? fileName.slice(0, 10) + '..' : fileName;
    let imgType = contentType.includes('image');
    return(
        <div key={index} className="document font-weight-bold my-2 mr-4">
            <div onClick={() => (imgType ? handlePreviewDocument(documentId) : null)} style={{width: '130px', height: '130px', margin: '0 auto', cursor: (imgType ? 'pointer' : 'default')}}>
                {imgType ? <img src={thumbnailUrl} alt="Thumbnail" width="100%" height="100%" />
                : <img src={'/Assets/nopreview.png'} alt="Thumbnail" style={{width: '130px', height: 'auto'}} />}
            </div>
            <div className="d-flex align-items-center justify-content-between position-absolute bottom-0 bg-white p-2 w-100">
                <p style={{cursor: (imgType ? 'pointer' : 'default')}} onClick={() => (imgType ? handlePreviewDocument(documentId) : null)} className="m-0">{fileName}</p>
                <FiDownload className="cursor-pointer" onClick={() => handleDownloadDocument(documentId)} />
                {/* <AiOutlineDelete className="cursor-pointer col-2 p-0" onClick={() => {setDeleteModal(true); setDeleteDocumentID(documentId)}} /> */}
            </div>
        </div>
    )}
;

export default UserDocuments;